import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import fnolTheme from '@fnol/library/src/themes/fnolTheme';
import MtplApp from './components/MtplApp';

// returns MotorApp (the app entry file) and providers

function App() {
    return (
        <>
            <CssBaseline />
            <ThemeProvider theme={fnolTheme}>
                <MtplApp />
            </ThemeProvider>
        </>
    );
}

export default App;
